import { render, staticRenderFns } from "./AddressSection.vue?vue&type=template&id=1ae977d0&scoped=true"
import script from "./AddressSection.vue?vue&type=script&lang=js"
export * from "./AddressSection.vue?vue&type=script&lang=js"
import style0 from "./AddressSection.vue?vue&type=style&index=0&id=1ae977d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae977d0",
  null
  
)

export default component.exports